import { Mail, Phone, MapPin, Send } from "lucide-react"

const ContactInfo = () => (
  <div className="contact-info-ini">
    <h3 className="contact-subtitle-ini">Información de contacto</h3>

    <div className="contact-item-ini">
      <div className="contact-icon-ini">
        <Mail size={20} color="white" />
      </div>
      <div>
        <h4 className="contact-label-ini">Email</h4>
        <p className="contact-text-ini">parkingclub064@gmail.com</p>
      </div>
    </div>

    <div className="contact-item-ini">
      <div className="contact-icon-ini">
        <Phone size={20} color="white" />
      </div>
      <div>
        <h4 className="contact-label-ini">Teléfono</h4>
        <p className="contact-text-ini">+593 984535202 (Ventas)</p>
        <p className="contact-text-ini">+593 997382016 (Soporte)</p>
      </div>
    </div>

    <div className="contact-item-ini">
      <div className="contact-icon-ini">
        <MapPin size={20} color="white" />
      </div>
      <div>
        <h4 className="contact-label-ini">Oficina principal</h4>
        <p className="contact-text-ini">Av Eloy Alfaro e Inglaterra, Ciudad Quito</p>
        <p className="contact-text-ini">Lunes a Viernes: 9am - 6pm</p>
      </div>
    </div>
  </div>
)

const ContactForm = () => (
  <div className="contact-form-container-ini">
    <h3 className="contact-subtitle-ini">Envíanos un mensaje</h3>
    <form className="contact-form-ini">
      <div className="form-row-ini">
        <div className="form-group-ini">
          <label htmlFor="nombre" className="form-label-ini">
            Nombre
          </label>
          <input type="text" id="nombre" className="form-input-ini" placeholder="Tu nombre" />
        </div>
        <div className="form-group-ini">
          <label htmlFor="email" className="form-label-ini">
            Email
          </label>
          <input type="email" id="email" className="form-input-ini" placeholder="tu@email.com" />
        </div>
      </div>

      <div className="form-group-ini">
        <label htmlFor="asunto" className="form-label-ini">
          Asunto
        </label>
        <input type="text" id="asunto" className="form-input-ini" placeholder="Asunto de tu mensaje" />
      </div>

      <div className="form-group-ini">
        <label htmlFor="mensaje" className="form-label-ini">
          Mensaje
        </label>
        <textarea
          id="mensaje"
          rows={5}
          className="form-textarea-ini"
          placeholder="Escribe tu mensaje aquí..."
        ></textarea>
      </div>

      <button type="submit" className="form-submit-ini">
        Enviar mensaje <Send size={16} className="ml-2" />
      </button>
    </form>
  </div>
)

export default function ContactanosSection() {
  return (
    <section className="contact-section-ini">
      <div className="container-ini">
        <div className="section-header-ini">
          <h2 className="section-title-ini">Estamos aquí para ayudarte</h2>
          <p className="section-description-ini">
            Nuestro equipo está listo para responder tus preguntas y ayudarte a implementar la mejor solución para tu
            parqueadero.
          </p>
        </div>
        <div className="contact-content-ini">
          <ContactInfo />
          <ContactForm />
        </div>
      </div>
    </section>
  )
}
